import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addFromCalculator } from '../Actions/Cart.action';
import { translate } from "../Services/translation";
import { setWidth, setLength, setApplyCompression, setVolume, setDepth, setArea } from '../Actions/QuantityCalculator.action';

const QuantityCalculator = ({
    density,
    calculatorVariants,
    showCompressionCheckbox
}) => {
    const { width, length, applyCompression, volume, area, depth } = useSelector((state) => state.quantityCalculator);
    const [widthText, setWidthText] = useState(width > 0 ? String(width).replace(".", ",") : "0,00");
    const [lengthText, setLengthText] = useState(length > 0 ? String(length).replace(".", ",") : "0,00");
    const [volumeText, setVolumeText] = useState(volume > 0 ? String(volume).replace(".", ",") : "0,00");
    const [areaText, setAreaText] = useState(area > 0 ? String(area).replace(".", ",") : "0,00");
    const [depthText, setDepthText] = useState(depth);
    const [calculatedWeight, setCalculatedWeigth] = useState("0,00");
    const [products, setProducts] = useState(calculatorVariants);
    const [totalPrice, setTotalPrice] = useState(0);
    const [totalProductWeight, setTotalProductWeight] = useState("0,00");
    const dispatch = useDispatch();

    useEffect(() => {
        if (width > 0 && length > 0) {
            const calculatedArea = width * length;
            dispatch(setArea(calculatedArea));
            setAreaText(calculatedArea.toFixed(2).replace(".", ","));
        }
    }, [width, length])

    useEffect(() => {
        let calculatedVolume = volume;

        if (depth > 0 && area > 0) {
            calculatedVolume = area * (depth / 100);
            dispatch(setVolume(calculatedVolume));
            setVolumeText(calculatedVolume.toFixed(2).replace(".", ","));
        }
        
        if (calculatedVolume > 0) {
            let weight = applyCompression && showCompressionCheckbox ? calculatedVolume * density * 1.15 : calculatedVolume * density;
            setCalculatedWeigth(weight.toFixed(2).replace(".", ","));
        }

    }, [depth, area, applyCompression]);
    
    useEffect(() => {
        let remainingWeight = parseFloat(calculatedWeight.replace(",", ".")) * 1000;
        let clonedVariants = [...calculatorVariants];
        
        clonedVariants.map(variant => {
            variant.quantity = 0;
        });

        while (remainingWeight > 0) {
            for(let i = clonedVariants.length - 1; i >= 0; i--) {
                let weightAfterAdding = remainingWeight - clonedVariants[i].weight;
                if (weightAfterAdding <= 0 || i == 0) {
                    clonedVariants[i].quantity += 1;
                    remainingWeight -= clonedVariants[i].weight;
                    break;
                }
            }
        }

        setProducts(clonedVariants);
        
    }, [calculatedWeight]);
    
    useEffect(() => {

        let price = 0;
        let productWeight = 0;
        for (const product of products) {
            const productPrice = product.priceModel.campaignPrice ? product.priceModel.campaignPrice.priceWithVat : product.priceModel.price.priceWithVat;
            price += productPrice * product.quantity;
            productWeight += product.weight * product.quantity;
            const inputElement = document.getElementById("input" + product.articleNumber);
            if (inputElement !== document.activeElement) {
                inputElement.value = product.quantity;
            }
        }

        productWeight /= 1000;
        setTotalPrice(Math.ceil(price));
        setTotalProductWeight(productWeight.toFixed(2).replace(".", ","));
        
    }, [products]);
    
    const changeVolume = (changedVolume) => {
        setVolumeText(changedVolume)
        if (changedVolume === "") {
            changedVolume = "0"
        }
        const volumeFloat = parseFloat(changedVolume.replace(",", "."))
        setAreaText("0,00");
        setWidthText("0,00");
        setLengthText("0,00");
        setDepthText("0");
        dispatch(setVolume(volumeFloat));
        dispatch(setWidth(0));
        dispatch(setDepth(0));
        dispatch(setLength(0))
        dispatch(setArea(0));
        const weight = applyCompression ? volumeFloat * density * 1.15 : volumeFloat * density;
        setCalculatedWeigth(weight.toFixed(2).replace(".", ","));
    };

    const changeArea = (changedArea) => {
        dispatch(setArea(parseFloat(changedArea)));
        setAreaText(changedArea);
        setWidthText("0,00");
        setLengthText("0,00");
        dispatch(setWidth(0));
        dispatch(setLength(0));
    }

    const changeProductQuantity = (articleNumber, newQuantity) => {
        setProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.articleNumber === articleNumber
              ? { ...product, quantity: newQuantity >= 0 ? Math.floor(newQuantity) : 0 }
              : product
          )
        );
      };
    
    const addToCart = () => {
        dispatch(addFromCalculator(products));
    }

    const formatPrice = (value, separator = ' ') => {
        const stringValue = value.toString();
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    };

    const checkKeyDown = (event) => {
        if (!/^[\d.,]$/.test(event.key) && !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(event.key)) {
            event.preventDefault();
        }
    }

    const quantityKeyDown = (event) => {
        if (!/^\d$/.test(event.key) && !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"].includes(event.key)) {
            event.preventDefault();
        }
    }

    return (
        <>
            <div className="quantity-calculator__container" id="quantityCalculatorContainer">
                <p className='quantity-calculator__section-title'>{translate("quantityCalculatorSizeDescription")}</p>
                <div className="quantity-calculator__top-rows">
                    <div className="quantity-calculator__item">
                        <label for="width">{translate("quantityCalculatorWidth")}</label>
                        <input 
                            type="text"
                            id="width"
                            value={widthText}
                            onChange={(event) =>  {
                                dispatch(setWidth(parseFloat(event.target.value.replace(",", "."))));
                                setWidthText(event.target.value);
                            }} 
                            onKeyDown={(event) => checkKeyDown(event)}
                            onFocus={(e) => {
                                if(e.target.value === '0,00') {
                                    e.target.value = "";
                                }
                            }}
                            onBlur={(e) => {
                                if (e.target.value === '') {
                                    setWidthText("0,00");
                                    dispatch(setWidth(0));
                                } 
                            }}
                            >
                        </input>
                    </div>
                    <div className="quantity-calculator__item">
                        <label for="length">{translate("quantityCalculatorLength")}</label>
                        <input 
                            type="text"
                            id="length"
                            value={lengthText}
                            onChange={(event) => {
                                dispatch(setLength(parseFloat(event.target.value.replace(",", "."))));
                                setLengthText(event.target.value);
                            }} 
                            onKeyDown={(event) => checkKeyDown(event)}
                            onFocus={(e) => {
                                if(e.target.value === '0,00') {
                                    e.target.value = "";
                                }
                            }}
                            onBlur={(e) => {
                                if (e.target.value === '') {
                                    setLengthText("0,00");
                                    dispatch(setLength(0));
                                }
                            }}
                            >
                        </input>
                    </div>
                    <div className="quantity-calculator__item">
                        <label for="area">{translate("quantityCalculatorArea")}</label>
                        <input 
                            type="text"
                            id="area"
                            value={areaText}
                            onChange={(event) => changeArea(event.target.value)} 
                            onKeyDown={(event) => checkKeyDown(event)}
                            onFocus={(e) => {
                                if(e.target.value === '0,00') {
                                    e.target.value = "";
                                }
                            }}
                            onBlur={(e) => {
                                if (e.target.value === '') {
                                    setAreaText("0,00");
                                    dispatch(setArea(0));
                                }
                            }}
                            >
                        </input>
                    </div>
                </div>
                <p className='quantity-calculator__section-title'>{translate("quantityCalculatorVolumeDescription")}</p>
                <div className="quantity-calculator__top-rows">
                    <div className="quantity-calculator__item">
                        <label for="depth">{translate("quantityCalculatorDepth")}</label>
                        <input 
                            type="text"
                            id="depth"
                            value={depthText}
                            onChange={(event) => {
                                dispatch(setDepth(parseFloat(event.target.value.replace(",", "."))));
                                setDepthText(event.target.value);
                            }} 
                            onKeyDown={(event) => checkKeyDown(event)}
                            onFocus={(e) => {
                                if(e.target.value === '0') {
                                    e.target.value = "";
                                }
                            }}
                            onBlur={(e) => {
                                if (e.target.value === '') {
                                    setDepthText("0");
                                    dispatch(setDepth(0));
                                }
                            }}
                            >
                        </input>
                    </div>
                    <div className="quantity-calculator__item">
                        <label for="volume">{translate("quantityCalculatorVolume")}</label>
                        <input 
                            type="text"
                            id="volume"
                            value={volumeText}
                            onKeyDown={(event) => checkKeyDown(event)}
                            onChange={(event) => changeVolume(event.target.value)} 
                            onFocus={(e) => {
                                if(e.target.value === '0,00') {
                                    e.target.value = "";
                                }
                            }}
                            onBlur={(e) => {
                                if (e.target.value === '') {
                                    setVolumeText("0,00");
                                    dispatch(setVolume(0));
                                }
                            }}
                            >
                        </input>
                    </div>
                    <div className="quantity-calculator__calculated-weight">
                        <p>{translate("quantityCalculatorCalculatedWeight")}</p>
                        {calculatedWeight !== "0,00" ? (
                            <p>{calculatedWeight} ton</p>
                        ) : (
                            <p>0,00 ton</p>
                        )}
                    </div>
                </div>
                {showCompressionCheckbox && (
                    <div className="quantity-calculator__checkbox-wrap">
                        <input
                            type="checkbox"
                            id="compression"
                            checked={applyCompression}
                            onChange={() => dispatch(setApplyCompression(!applyCompression))}>
                        </input>
                        <label for="compression">{translate("quantityCalculatorAddCompression")}</label>
                    </div>
                )}
                <div className='quantity-calculator__products'>
                {products.map((product) => {
                return (
                    <div key={product.articleNumber} className="quantity-calculator__product-item">
                        <div className='product-info'>
                            <p className='product-name'>{product.name}</p>
                            <div className='product-price'>
                                {product.priceModel.campaignPrice ? (
                                    <div className='campaign'>
                                        <p className='new-price'>{Math.ceil(product.priceModel.campaignPrice.priceWithVat)} kr/st</p>
                                        <p className='old-price'>{product.priceModel.price.priceWithVat} kr/st</p>
                                    </div>
                                ) : (
                                    <p>
                                        {product.priceModel.price.priceWithVat} kr/st
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className='product-quantity'>
                            <button className='quantity-button' onClick={() => changeProductQuantity(product.articleNumber, product.quantity - 1)}>-</button>
                            <input
                                type="text"
                                id={"input" + product.articleNumber}
                                onFocus={(e) => {
                                    if(e.target.value === '0') {
                                        e.target.value = "";
                                    }
                                }}
                                onKeyDown={(event) => quantityKeyDown(event)}
                                onChange={(e) => changeProductQuantity(product.articleNumber, Number(e.target.value))}
                                onBlur={(e) => {
                                    if (e.target.value === '') {
                                        changeProductQuantity(product.articleNumber, 0)
                                        e.target.value = '0';
                                    }
                                }}
                                >
                            </input>
                            <label for={"input" + product.articleNumber}>st</label>
                            <button className='quantity-button' onClick={() => changeProductQuantity(product.articleNumber, product.quantity + 1)}>+</button>
                        </div>
                    </div>
                    );
                })}
                </div>
                <div className='quantity-calculator__summary-row'>
                    <div className='quantity-calculator__summary-column'>
                        <div className="quantity-calculator__summary-item">
                            <p className='description'>{translate("quantityCalculatorWeight")}</p>
                            {totalProductWeight !== "0,00" ? (
                                <p className='total'>{totalProductWeight} ton</p>
                            ) : (
                                <p className='total'>0,00 ton</p>
                            )}
                        </div>
                        <div className="quantity-calculator__summary-item">
                            <p className='description'>{translate("quantityCalculatorTotalPrice")}</p>
                            <p className='total'>{formatPrice(totalPrice)} kr</p>
                        </div>
                    </div>
                    <button className="button" disabled={totalPrice == 0} onClick={addToCart}>{translate("quantityCalculatorBuy")}</button>
                </div>
            </div>
        </>
    )
};

export default QuantityCalculator;
